var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52345 0.726563C9.94923 1.15235 9.94923 1.84766 9.52345 2.27344L4.52344 7.27345C4.09766 7.69923 3.40235 7.69923 2.97657 7.27345L0.476563 4.77345C0.0507811 4.34766 0.0507811 3.65235 0.476563 3.22657C0.902345 2.80079 1.59766 2.80079 2.02344 3.22657L3.75001 4.95313L7.97658 0.726563C8.40236 0.300781 9.09767 0.300781 9.52345 0.726563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.cf0c92435790a6edac1f708df5fec443.svg";
export { ForwardRef as ReactComponent };